const PLUGIN_TYPE_MAP = {
  LineBreak: 'Basic',
} as const;

export const migrateLineBreakSystemDefaultValue = (dataType: any) => {
  const system = dataType?.system;
  const defaultValue = system?.defaultValue;

  if (
    Array.isArray(defaultValue) &&
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly LineBreak: "Basic"; }'.
    defaultValue.some((value) => PLUGIN_TYPE_MAP[value.type])
  ) {
    return {
      ...dataType,
      system: {
        ...system,
        defaultValue: defaultValue.map((value) =>
          // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly LineBreak: "Basic"; }'.
          PLUGIN_TYPE_MAP[value.type]
            ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly LineBreak: "Basic"; }'.
              {...value, pluginType: PLUGIN_TYPE_MAP[value.type]}
            : value
        ),
      },
    };
  }

  return dataType;
};
